<template>
  <Empty :image="Empty.PRESENTED_IMAGE_SIMPLE" class="table-empty-add">
    <MButton v-if="!disabled && action" v-bind="action">
      {{ t(action.label || 'common.addText') }}
    </MButton>
    <slot></slot>
  </Empty>
</template>

<script lang="ts" setup>
  import { Empty } from 'ant-design-vue';
  import { MButton } from '@mts/components/Button';
  import { ActionItem } from '@mts/components/Table';
  import { t } from '@mts/hooks/web/useI18n';

  defineOptions({ name: 'TableEmptyAdd' });

  withDefaults(
    defineProps<{
      disabled?: boolean;
      action?: ActionItem;
    }>(),
    { disabled: true },
  );
</script>

<style lang="less">
  .ant-empty.table-empty-add {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 120px;
    margin: 0;

    .ant-empty-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      margin-top: 0;
    }
  }
</style>
